import useSWRInfinite from 'swr/infinite'
import NewsItem from '../components/News'

export function renderNews (data) {
  return !data ? null : data.reduce((a, v) => a.concat(v.results.map(n => (
    <li key={n.link}>
      <NewsItem {...n} />
    </li>
  ))), [])
}

export function useNews (locale, count = 20) {
  const { data, error, size, setSize, mutate: updateNews } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      return [!pageIndex ? '/api/newsfeed?length=' + count : previousPageData.next, false]
    }, {
      refreshInterval: 300000
    })
  const page = !error && data?.[size - 1]
  const pages = renderNews(data, locale)
  return {
    pages,
    isLoadingInitialData: !error && !data,
    isLoadingMore: !page,
    isEmpty: !!page && !pages?.length,
    error,
    loadMore: () => setSize(size + 1),
    isReachingEnd: !!page && !page.next,
    updateNews
  }
}
